
export const scrollToReference = reference => window.scrollTo(0, reference.current.offsetTop);

// export const scrollToReference = reference => reference.current.scrollTo(0, reference.current.offsetTop);

// export const scrollToReference = reference => reference.current.scrollIntoView();
